<template>
  <v-app id="instarent">

    <div class="top-conceal fixed z4"></div>
    <div class="bottom-conceal fixed z3"></div>
    
    <i-navigation :drawer="drawer" @retract="drawer = !drawer" />

    <v-app-bar
      app
      color="i-darkblue"
      elevation=6
      dark
    >
      <v-spacer v-if="!mobile" />

      <v-scale-transition>
        <v-toolbar-title v-if="$keys[3]" class="display-1 i-lightrose--text "><b>i</b></v-toolbar-title>
      </v-scale-transition>
      
      <v-fade-transition>
        <v-toolbar-title v-if="$keys[0]" class="display-1 i-powderblue--text mr-1">nstarent</v-toolbar-title>
      </v-fade-transition>

      <v-fab-transition>
        <v-toolbar-title v-if="$keys[3]" class="display-1 i-blue i-powderblue--text pr-1 pl-1">hub</v-toolbar-title>
      </v-fab-transition>

      <v-spacer />

      <v-app-bar-nav-icon
      v-if="mobile"
      class="i-powderblue--text"
      @click.stop="toggleNav" />

    </v-app-bar>

    <v-content>
      <router-view />
    </v-content>

    <v-footer
      app
      color="i-blue"
      elevation=3
      fixed>

      <v-spacer />

      <span justify="center" class="i-powderblue--text z5">&copy; Copyright Instarent 2020</span>

      <v-spacer />
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: 'Instarent',

  props: {
      source: String,
    },

  data: () => ({
    drawer: null
  }),

  computed: {
    mobile () {
      let value
      window.innerWidth <= 760
      ? value = true
      : value = false

      return value
    }
  },

  methods: {
    toggleNav () {
      this.drawer
      ? this.drawer = !this.drawer
      : this.drawer = true
    }
  },

  mounted() {
    // send 'this.$classes' to the store and make it accessible to all components
  },

  hasAnim: true
};
</script>

<style>
html {overflow: auto !important;}

body {overflow: hidden !important;}

/* MOBILE */
@media screen and (max-width: 1023px) {
  header {
    border-radius: 1.5rem 1.5rem 0px 0px !important;
  }
}


/* DESKTOP */
@media screen and (min-width: 1024px) {
  header {
    border-radius: 0px 1.5rem 0px 0px !important;
  }
}

.top-conceal {
  height: 1.5rem;
  width: 100vw;
  top: 0px;
  background: black;
}

.bottom-conceal {
  height: 1.5rem;
  width: 100vw;
  bottom: 0px;
  background: black;
}

footer {
  border-radius: 0px 0px 1.5rem 1.5rem !important;
}
</style>
